import { Card } from "@material-tailwind/react";
import { useFileViewer } from "../../../Context/FileViewerContext";
import { useWorkspaceStore } from "../../../Context/store";
import { getLocalTime } from "../../../Utils/Helper";
import ImageOrInitials from "../../Functionality/ImageOrInitials";

const CitationCard = ({ citation, type }) => {
  const { handleFile } = useFileViewer();
  const { selectedWorkspace } = useWorkspaceStore();

  const motionUploadFilePath = `${process.env.REACT_APP_MOTION_UPLOAD}/${selectedWorkspace?.workSpaceId}`;

  const createFileURL = (type, url) => {
    if (type === "motion") {
      return `${process.env.REACT_APP_AZURE_STORAGE_BASE_URL}/debatemodule/${motionUploadFilePath}/${url}`;
    } else {
      return url;
    }
  };

  return (
    <Card className="flex p-2 flex-col md:flex-row  gap-2 items-start ">
      <ImageOrInitials
        imageSrc={citation?.createdByUserImage}
        initials={citation?.createdByUserName}
      />
      <div className="w-full flex flex-col gap-1">
        <div className="flex flex-col gap-2 w-full">
          <p className="truncate whitespace-pre-wrap text-sm font-semibold">
            {citation?.citationTitle}
          </p>
          {citation?.citationNote && (
            <p className="truncate whitespace-pre-wrap text-sm">
              {citation?.citationNote}
            </p>
          )}
        </div>
        <p
          className="text-sm text-wrap break-all text-debatePalette-link hover:underline cursor-pointer"
          onClick={(e) => {
            e.preventDefault(); // Prevent default download behavior
            if (citation?.citationFileType === "url") {
              window.open(citation?.citationUrl, "_blank");
              return;
            }
            handleFile({
              fileUrl: createFileURL(type, citation?.citationUrl),
              fileType: citation?.citationFileType,
              fileName: citation?.citationUrl,
              fileUploadedAt: getLocalTime(citation?.createdAt),
              createdBy: citation?.createdByUserName,
              creatorImage: citation?.createdByUserImage,
              channelName: selectedWorkspace?.workSpaceName,
            });
          }}
        >
          {citation?.citationTitle}
        </p>
        <span className="text-xs text-debatePalette-bodyText">
          {getLocalTime(citation?.createdAt)}
        </span>
      </div>
    </Card>
  );
};

export default CitationCard;
